module.exports = __webpack_public_path__ + "img/freespin_feature.bd3b6e30.png";